import {
  Component, OnInit, OnDestroy
} from '@angular/core';
import {
  FormGroup, Validators, ValidatorFn, ValidationErrors, FormControl
} from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import PrescriptionRxService from 'app/entities/prescription-rx/prescription-rx.service';
import { SessionStorageService } from 'ngx-webstorage';
import {
  STATE_DATA,
  passwordErrorMustContainLowercase,
  passwordErrorMustContainUppercase,
  passwordErrorMustContainNumericOrSpecialChar,
  passwordErrorNoSpace,
  passwordErrorMinimum14Chars,
  passwordErrorCannotContainUsername,
  passwordErrorCannotContainFirstOrLastName
} from 'app/app.constants';
import AccountService from 'app/core/auth/account.service';
import { takeUntil } from 'rxjs/operators';
import AddressValidationDialogService from 'app/core/address-validation-dialog/address-validation-dialog.service';
import { FormatPhoneNumber } from 'app/shared/util/request-util';
import UspsAddressResponse from 'app/core/usps/usps-address-request/usps-address-response.model';
import UspsAddressRequest from 'app/core/usps/usps-address-request/usps-address-request.model';
import ProfileRxService from '../profile-rx.service';

@Component({
  selector: 'jhi-profile-rx-update',
  templateUrl: './profile-rx-update.component.html',
  styleUrls: ['./profile-rx-update.scss']
})
export default class ProfileRxUpdateComponent implements OnInit, OnDestroy {
  private profileRxUpdateComponent$: Subject<void> = new Subject<void>();

  isSaving: boolean;

  showmessage;

  error;

  success;

  message;

  submitted = false;

  profile;

  emailCount = 1;

  emailAddress;

  primaryPhoneNumberObj;

  pharmacyList;

  stateList;

  currentAccount;

  editForm: any;

  slideScreen;

  isApicalled = false;

  showLoader = true;

  primaryPatientId;

  isInvalidAddress = false;

  successResponse = 'Success';

  addressOld;

  constructor(
    protected profileService: ProfileRxService,
    private prescriptionService: PrescriptionRxService,
    private sessionStorage: SessionStorageService,
    private accountService: AccountService,
    private router: Router,
    private addressValidationDialogService: AddressValidationDialogService
  ) {}

  ngOnInit() {
    this.accountService.slideScreen.pipe(takeUntil(this.profileRxUpdateComponent$)).subscribe((data) => {
      this.slideScreen = data;
    });
    this.isSaving = false;
    this.getPharmacyList();
    this.stateList = STATE_DATA;
    this.profile = JSON.parse(this.sessionStorage.retrieve('profile-details'));
    this.primaryPatientId = JSON.parse(this.sessionStorage.retrieve('primarypatientid'));
    this.accountService.identity().then((account) => {
      this.currentAccount = account;
      if (this.profile) {
        this.editForm = new FormGroup(
          {
            primaryEmailAddress: new FormControl(null, [
              Validators.required,
              Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,}$')
            ]),
            primaryPhoneNumber: new FormControl(null, [Validators.required, Validators.minLength(14)]),
            defaultPharmacy: new FormControl(null, [Validators.required]),
            addressLine: new FormControl(null, [Validators.maxLength(50)]),
            addressCity: new FormControl(null, [Validators.maxLength(50)]),
            addressState: new FormControl(null, [Validators.maxLength(50)]),
            addressZip: new FormControl(null, [Validators.maxLength(10)]),
            newpassword: new FormControl(''),
            confirmPassword: new FormControl('')
          },
          this.validateForm(this.currentAccount)
        );
        if (this.currentAccount.enterpriseRxPatientId === this.profile.patientId) {
          this.currentAccount.firstName = this.profile.firstName;
          this.currentAccount.lastName = this.profile.lastName;
        }
        this.updateForm();
      }
    });
  }

  updateForm() {
    if (this.profile.patientEmailList) {
      this.profile.patientEmailList = this.profile.patientEmailList.sort((a, b) => a.emailRank - b.emailRank);
      this.emailCount = this.profile.patientEmailList.length;
      this.emailAddress = this.profile.patientEmailList[0] ? this.profile.patientEmailList[0].emailAddress : '';
    }
    this.primaryPhoneNumberObj =
      this.profile.patientAddressDTO && this.profile.patientAddressDTO.primaryPhone ? this.profile.patientAddressDTO : '';

    this.editForm.get('primaryEmailAddress').setValue(this.emailAddress);

    if (this.profile.patientAddressDTO) {
      this.editForm.get('addressLine').setValue(this.profile.patientAddressDTO.line1);
      this.editForm.get('addressCity').setValue(this.profile.patientAddressDTO.city);
      this.editForm.get('addressState').setValue(this.profile.patientAddressDTO.state);
      this.editForm.get('addressZip').setValue(this.profile.patientAddressDTO.zip);
      this.addressOld = {
        streetAddress: this.profile.patientAddressDTO.line1,
        city: this.profile.patientAddressDTO.city,
        state: this.profile.patientAddressDTO.state,
        ZIPCode: this.profile.patientAddressDTO.zip
      };
    }
    this.editForm.get('primaryPhoneNumber')
      .setValue(
        this.primaryPhoneNumberObj.primaryPhone.phoneNumber ? FormatPhoneNumber(this.primaryPhoneNumberObj.primaryPhone.phoneNumber) : ''
      );
  }

  getValidPhoneNumber(phoneNumber): string {
    phoneNumber = phoneNumber.replaceAll(/[^\d]/g, '');
    return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3, phoneNumber.length)}`;
  }

  isPhoneChange(): boolean {
    const formPhone = this.editForm.get('primaryPhoneNumber').value.replaceAll(/[^\d]/g, '');
    return this.primaryPhoneNumberObj.primaryPhone.phoneNumber !== formPhone;
  }

  isEmailChange(): boolean {
    return this.emailAddress !== this.editForm.get('primaryEmailAddress').value;
  }

  isAddressChange(): boolean {
    return this.editForm.get('addressLine').value !== this.profile.patientAddressDTO.line1
      || this.editForm.get('addressCity').value !== this.profile.patientAddressDTO.city
      || this.editForm.get('addressState').value !== this.profile.patientAddressDTO.state
      || this.editForm.get('addressZip').value !== this.profile.patientAddressDTO.zip;
  }

  createPayload() {
    let hasEdits = false;
    const userEdits = {
      emails: [],
      phoneNumbers: [],
      shippingAddress: null
    };
    const payload = {
      admin: false,
      firstName: this.profile.firstName,
      lastName: this.profile.lastName,
      username: '',
      password: '',
      defaultPharmacy: this.editForm.value.defaultPharmacy,
      primaryUserPatientId: this.primaryPatientId,
      deletes: [],
      edits: [],
      patientId: this.profile.enterpriseRxId
    };
    if (this.isPhoneChange() || this.isAddressChange()) {
      hasEdits = true;
      const phoneChange: string = this.getValidPhoneNumber(this.editForm.value.primaryPhoneNumber);
      userEdits.phoneNumbers = [
        {
          phonenumber: phoneChange,
          type: 'Cell',
          usage: 'Cell'
        }
      ];
      userEdits.shippingAddress = {
        address: this.editForm.value.addressLine,
        city: this.editForm.value.addressCity,
        phoneNumbers: [
          {
            phonenumber: phoneChange,
            type: 'Primary',
            usage: 'Primary'
          }
        ],
        state: this.editForm.value.addressState,
        zipCode: this.editForm.value.addressZip
      };
    }
    if (this.isEmailChange()) {
      hasEdits = true;
      const emailChange = this.editForm.value.primaryEmailAddress;
      userEdits.emails = [
        {
          address: emailChange,
          rank: '1',
          useForNotifier: true
        }
      ];
    }
    if (hasEdits) {
      payload.edits.push(userEdits);
    }
    if (this.currentAccount.username) {
      payload.username = this.currentAccount.username;
    }
    if (this.editForm.value.newpassword) {
      payload.password = this.editForm.value.newpassword;
    }
    return payload;
  }

  previousState() {
    this.router.navigate(['/profile-rx']);
  }

  validateAddress(addressData: UspsAddressRequest) {
    this.profileService.validateAddress(addressData)
      .pipe(takeUntil(this.profileRxUpdateComponent$))
      .subscribe({
        next: (uspsRes) => {
          const usps = uspsRes?.body;
          if (usps === null || usps?.error) {
            this.showLoader = true;
            this.isApicalled = false;
            if (usps === null) {
              this.message = 'Invalid address';
            } else if (usps.error) {
              this.message = usps.error?.text;
            }
            this.isInvalidAddress = true;
            this.error = true;
            this.showmessage = true;
            this.editForm.setErrors({ address: 'error' });
          } else {
            const uspsAddress = uspsRes?.body;
            if (this.addressDoesNotMatchUsps(addressData, uspsAddress.address)) {
              this.showUspsAddressConfirmation(uspsRes.body);
            } else if (!this.editForm.invalid) {
              this.updateProfile();
            } else {
              this.showLoader = true;
              this.isApicalled = false;
            }
          }
        },
        error: () => {
          this.showLoader = true;
          this.isApicalled = false;
          this.error = true;
          this.showmessage = true;
        }
      });
  }

  addressDoesNotMatchUsps(addressData: UspsAddressRequest, usps: UspsAddressResponse) {
    return this.profileService.addressDoesNotMatchUsps(addressData, usps);
  }

  showUspsAddressConfirmation(usps: UspsAddressResponse) {
    this.showLoader = true;
    this.addressValidationDialogService.confirm(
      'USPS Address Validation Response',
      usps?.address?.streetAddress,
      this.editForm.value.addressLine,
      usps?.address?.city,
      this.editForm.value.addressCity,
      usps?.address.state,
      this.editForm.value.addressState,
      usps?.address.ZIPCode,
      this.editForm.value.addressZip,
      'lg'
    ).then((confirmed) => {
      if (confirmed === 'user') {
        // User choose to keep their own - update
        if (!this.editForm.invalid) {
          this.updateProfile();
        } else {
          this.showLoader = true;
          this.isApicalled = false;
        }
      } else if (confirmed === 'usps') {
        // user choose to use USPS data
        // overwrite with usps and update
        this.editForm.get('addressLine').setValue(usps?.address.streetAddress);
        this.editForm.get('addressCity').setValue(usps?.address.city);
        this.editForm.get('addressZip').setValue(usps?.address.ZIPCode);
        this.editForm.get('addressState').setValue(usps?.address.state);
        if (!this.editForm.invalid) {
          this.updateProfile();
        } else {
          this.showLoader = true;
          this.isApicalled = false;
        }
      } else if (confirmed === 'edit') {
        this.showLoader = true;
        this.isApicalled = false;
      } else if (confirmed === 'timeout') {
        this.showLoader = true;
        this.isApicalled = false;
      }
    });
  }

  save() {
    this.submitted = true;
    this.showLoader = false;
    this.isInvalidAddress = false;
    const addressData = {
      streetAddress: this.editForm.value.addressLine,
      city: this.editForm.value.addressCity,
      state: this.editForm.value.addressState,
      ZIPCode: this.editForm.value.addressZip.toString()
    };
    if (this.isApicalled === false) {
      this.isApicalled = true;
      if (this.addressOld && JSON.stringify(this.addressOld) !== JSON.stringify(addressData)) {
        this.validateAddress(addressData);
      } else {
        this.updateProfile();
      }
    }
    this.isApicalled = true;
  }

  private updateProfile() {
    this.profileService.update(this.createPayload())
      .pipe(takeUntil(this.profileRxUpdateComponent$))
      .subscribe({
        next: (res) => {
          this.isApicalled = false;
          this.showmessage = true;
          this.showLoader = true;
          if (
            (res.body.updatePasswordResponse === null || res.body.updatePasswordResponse === this.successResponse) &&
            (res.body.setDefaultPharmacyResponse === null || res.body.setDefaultPharmacyResponse === this.successResponse) &&
            (res.body.updatePatientDetailsResponse === null || res.body.updatePatientDetailsResponse === this.successResponse)
          ) {
            this.success = true;
            this.error = false;
            this.message = 'Profile updated successfully';
          } else {
            this.success = false;
            this.error = true;
            if (res.body.updatePasswordResponse !== this.successResponse) {
              this.message = res.body.updatePasswordResponse;
            } else if (res.body.setDefaultPharmacyResponse !== this.successResponse) {
              this.message = res.body.setDefaultPharmacyResponse;
            } else if (res.body.updatePatientDetailsResponse !== this.successResponse) {
              this.message = res.body.updatePatientDetailsResponse;
            }
          }
        },
        error: (error: any) => {
          this.showmessage = true;
          this.isApicalled = false;
          this.success = false;
          this.error = true;
          this.showLoader = true;
          this.message = error.error.detail ? error.error.detail : 'There was a problem updating your profile, please try again.';
        }
      });
  }

  getPharmacyList() {
    this.prescriptionService
      .getPharmacyList()
      .pipe(takeUntil(this.profileRxUpdateComponent$))
      .subscribe((res) => {
        this.pharmacyList = res.body;
        if (this.profile.defaultPharmacyId) {
          const tempPharmacyList = this.pharmacyList.filter(
            (pharmacy) => parseInt(pharmacy.pharmacyId, 10) === parseInt(this.profile.defaultPharmacyId, 10)
          );

          if (tempPharmacyList.length > 0) {
            this.editForm.get('defaultPharmacy').setValue(this.profile.defaultPharmacyId);
          }
        }
      });
  }

  tryagain() {
    this.showmessage = false;
    this.success = false;
    this.error = false;
    this.isApicalled = false;
  }

  validateForm(userDetails): ValidatorFn {
    return (group: FormGroup): ValidationErrors | null => {
      const password = group.controls?.newpassword;
      const confirmpass = group.controls?.confirmPassword;
      let message: string;

      if (password.value && confirmpass.value) {
        const isMatch = password.value === confirmpass.value;
        if (!isMatch && password.valid) {
          confirmpass.setErrors({ equalValue: 'error' });
          message = 'error';
        }
      }

      const passValue = password.value.toLocaleLowerCase();
      if (password.value) {
        if (!password.value.match('^(?=.*?[A-Z])')) {
          message = 'error';
          password.setErrors({ error: passwordErrorMustContainUppercase });
        } else if (!password.value.match('^(?=.*?[a-z])')) {
          message = 'error';
          password.setErrors({ error: passwordErrorMustContainLowercase });
        } else if (!(password.value.match('^(?=.*?[0-9])') || password.value.match('^(?=.*?[-$_!%*&])'))) {
          message = 'error';
          password.setErrors({ error: passwordErrorMustContainNumericOrSpecialChar });
        }
        if (password.value.match('^[ ]*$')) {
          message = 'error';
          password.setErrors({ error: passwordErrorNoSpace });
        } else if (password.value.length < 14) {
          message = 'error';
          password.setErrors({ error: passwordErrorMinimum14Chars });
        }
      }
      if (passValue) {
        if (userDetails.username) {
          if (passValue.match(new RegExp(userDetails.username.toLocaleLowerCase()))) {
            message = 'error';
            password.setErrors({ error: passwordErrorCannotContainUsername });
          }
        }
        if (userDetails && userDetails.firstName) {
          if (passValue.match(userDetails.firstName.toLocaleLowerCase())) {
            message = 'error';
            password.setErrors({ error: passwordErrorCannotContainFirstOrLastName });
          }
        }

        if (userDetails && userDetails.lastName) {
          if (passValue.match(userDetails.lastName.toLocaleLowerCase())) {
            message = 'error';
            password.setErrors({ error: passwordErrorCannotContainFirstOrLastName });
          }
        }
      }

      if (message) {
        return { equalValue: message };
      }

      return null;
    };
  }

  public ngOnDestroy(): void {
    this.profileRxUpdateComponent$.next();
    this.profileRxUpdateComponent$.unsubscribe();
  }
}
